import { render } from "./ShipsTable.vue?vue&type=template&id=4768b1ba&scoped=true&lang=true"
import script from "./ShipsTable.vue?vue&type=script&lang=js"
export * from "./ShipsTable.vue?vue&type=script&lang=js"

import "./ShipsTable.vue?vue&type=style&index=0&id=4768b1ba&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4768b1ba"]])

export default __exports__